import classNames from '@utils/classnames';
import React from 'react';
import { Link, LinkProps } from 'react-router-dom';

import { Spinner } from '../Spinner';
import { buttonClassName, resolveButtonColor, type ButtonColor, type ButtonSize } from './BaseButton';

export interface LinkButtonProps extends LinkProps {
  color?: ButtonColor;
  size?: ButtonSize;
  isLoading?: boolean;
  iconLeft?: React.ReactElement;
  iconRight?: React.ReactElement;
  isDisabled?: boolean;
}

const DisabledLink: React.FC<LinkProps> = (props) => {
  const { children, className, style } = props;

  return (
    <div className={className} style={style}>
      {children}
    </div>
  );
};

/** A router `Link` that looks exactly like a `Button`. */
export const LinkButton: React.FC<LinkButtonProps> = (props) => {
  const {
    isLoading,
    isDisabled: _disabled,
    color = 'secondary',
    size = 10,
    children,
    className,
    iconLeft,
    iconRight,
    ...otherProps
  } = props;

  const isDisabled = _disabled || !otherProps.to;
  const canonical = resolveButtonColor(color);

  const ComponentClass = isDisabled || isLoading ? DisabledLink : Link;
  return (
    <ComponentClass {...otherProps} className={buttonClassName({ color, size, isDisabled, className })}>
      <span className={classNames('inline-flex items-center justify-center gap-1.5', { invisible: isLoading })}>
        {iconLeft != null && <span className="inline-flex shrink-0 items-center">{iconLeft}</span>}
        {children != null && <span>{children}</span>}
        {iconRight != null && <span className="inline-flex shrink-0 items-center">{iconRight}</span>}
      </span>
      {isLoading && (
        <span className="absolute inset-0 flex items-center justify-center">
          <Spinner size={4} color={canonical === 'primary' ? 'inverse' : 'default'} />
        </span>
      )}
    </ComponentClass>
  );
};
